/*********************** Custom JS for Boost AI Search & Discovery  ************************/

const updateProductItem = (componentRegistry) => {
  componentRegistry.useComponentPlugin("ProductItem", {
    name: "",
    enabled: true,
    apply: () => ({
      afterRender(element) {
        try {
          const btnTitle = document.querySelector(
            ".boost-sd__filter-tree-toggle-button-title"
          );
          
          if (btnTitle) {
            btnTitle.innerHTML = "Size";
          }
        } catch (e) {}
      },
    }),
  });
};

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  updateProductItem,
]);
